import { render, staticRenderFns } from "./TestMailConfirmModal.vue?vue&type=template&id=d140ccbe&lang=pug"
import script from "./TestMailConfirmModal.vue?vue&type=script&lang=ts"
export * from "./TestMailConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports